import { startOfMinute } from 'date-fns';

export const getNow = (): Date => startOfMinute(new Date());
